package com.essntl.features.proposal.ui.proposalhistory.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.ui.rememberDayRowUiStateList
import com.essntl.features.proposal.ui.rememberLocalDate
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberNumberOfDays
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlin.math.max

@Composable
fun ProposalJourneyDetails(
    proposal: ProposalModel,
    proposalServiceList: List<JourneyRowUiState>,
) {
    var isExpanded by rememberSaveable { mutableStateOf(true) }

    var isDaysProposalServiceListEmpty by remember { mutableStateOf(true) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(
                color = MaterialTheme.esColorScheme.bgSecondary,
                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
            )
            .padding(
                vertical = 2.spacing,
                horizontal = 2.5f.spacing,
            ),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = "See journey details",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.s2SemiBold16,
            )

            EsLargeIcon(
                res = EsIcons.ArrowDown,
                modifier = Modifier
                    .graphicsLayer {
                        transformOrigin = TransformOrigin.Center
                        rotationZ = if (isExpanded) 180f else 0f
                    }
                    .clip(CircleShape)
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                    ) {
                        isExpanded = !isExpanded
                    },
            )
        }

        val numberOfDays = rememberNumberOfDays(proposal.fromDate, proposal.toDate) ?: -1

        AnimatedVisibility(isExpanded) {
            Column(
                verticalArrangement = Arrangement.spacedBy(1.spacing),
                modifier = Modifier
                    .fillMaxWidth(),
            ) {
                Spacer(modifier = Modifier.height(3.spacing))

                repeat(max(0, numberOfDays)) { index ->
                    val localDate = rememberLocalDate(index, proposal.fromDate)

                    val dayProposalServiceList = rememberDayRowUiStateList(
                        localDate,
                        proposalServiceList,
                    )

                    if (dayProposalServiceList.isEmpty())
                        return@repeat

                    isDaysProposalServiceListEmpty = false

                    if (localDate != null)
                        key(localDate) {
                            ProposalJourneyDayRow(
                                day = "Day ${index + 1}",
                                localDate = localDate,
                                proposalServiceList = dayProposalServiceList,
                            )
                        }
                }

                if (isDaysProposalServiceListEmpty)
                    Text(
                        text = "No Services!",
                        color = MaterialTheme.esColorScheme.textSecondary,
                        style = MaterialTheme.esTypography.p1Medium16,
                    )
            }
        }
    }
}